module.exports = __webpack_public_path__ + "static/media/RKBrowser1w1100@2x.e7fb475d.jpg";